import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { userAtom } from '../state/userAtom'
import { useAtom } from 'jotai'
import { useAuth } from '../hooks/useAuth'
import { LinearProgress } from '@mui/material'
import { UserRole } from '../types/userRoles'

interface ProtectedRouteProps {
  children: React.ReactElement
  allowedRole: UserRole
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRole }) => {
  const location = useLocation()
  const { loading } = useAuth()
  const [user] = useAtom(userAtom)

  if (loading) {
    return <LinearProgress sx={{ height: '5px' }} />
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ returnTo: location.pathname + location.search }} />
  }

  if (user.role !== allowedRole) {
    return <Navigate to="/" />
  }

  return <>{children}</>
}

export default ProtectedRoute
